import { baseLocationSchema } from '@kominiarz/shared';
import { useEffect, useState } from 'react';
import { AddressField, type Coords } from '../../components/AddressField';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/Button';
import { Section } from '../../components/Section';
import { useToast } from '../../components/Toast';
import { errorMessage } from '../../lib/api';
import { useAppSettings, useSaveBaseLocation } from '../../lib/geoApi';

/** Manager: where the company is based (map centre, nearby addresses suggested first). */
export function BaseLocationSection() {
  const settings = useAppSettings();
  const save = useSaveBaseLocation();
  const toast = useToast();
  const base = settings.data?.baseLocation ?? null;
  const [label, setLabel] = useState('');
  const [coords, setCoords] = useState<Coords | null>(null);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (base) {
      setLabel(base.label);
      setCoords({ lat: base.lat, lng: base.lng });
    }
  }, [base?.label, base?.lat, base?.lng]); // eslint-disable-line react-hooks/exhaustive-deps

  async function submit() {
    const parsed = baseLocationSchema.safeParse({ label, lat: coords?.lat, lng: coords?.lng });
    if (!parsed.success) {
      setError(coords ? parsed.error.issues[0]!.message : 'Wskaż bazę na mapie: wybierz adres z podpowiedzi albo „Znajdź na mapie”.');
      return;
    }
    setError(undefined);
    try {
      await save.mutateAsync(parsed.data);
      toast.success('Zapisano bazę firmy');
    } catch (err) {
      setError(errorMessage(err));
    }
  }

  const changed = !base || base.label !== label || base.lat !== coords?.lat || base.lng !== coords?.lng;
  return (
    <Section title="Baza firmy" description="Środek map i punkt odniesienia dla podpowiedzi adresów: najpierw podpowiadane są adresy z okolicy.">
      {!base && settings.data && <Alert kind="warning">Baza firmy nie jest jeszcze ustawiona.</Alert>}
      <AddressField
        label="Adres bazy"
        value={label}
        coords={coords}
        onType={(a) => {
          setLabel(a);
          setCoords(null);
        }}
        onPick={(a, c) => {
          setLabel(a);
          setCoords(c);
        }}
        onPin={setCoords}
        error={error}
      />
      <div>
        <Button variant="primary" onClick={submit} disabled={!changed || save.isPending}>
          Zapisz bazę
        </Button>
      </div>
    </Section>
  );
}
